import { createEmotionCache } from '@/theme/emotion.cache';
import { CacheProvider } from '@emotion/react';
import { createContext, useContext, useMemo, useState } from 'react';

const ClientStyleCtx = createContext({
  reset: () => {},
});

export const ClientStyleProvider: React.FCC = ({ children }) => {
  const [cache, setCache] = useState(createEmotionCache());

  const val = useMemo(
    () => ({
      reset() {
        setCache(createEmotionCache());
      },
    }),
    []
  );

  return (
    <ClientStyleCtx.Provider value={val}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </ClientStyleCtx.Provider>
  );
};

export const useClientStyle = () => useContext(ClientStyleCtx);
